import { useMatchRoute } from '@tanstack/react-router';

export const PORTFOLIO_SURFACE_BASE = '/org/$org/loop/$loopId/portfolio' as const;
export const PORTFOLIO_SAVED_VIEW_BASE = '/org/$org/loop/$loopId/portfolio/view/$viewId' as const;

export type ViewSurfacePaths = {
  isMergedPortfolio: boolean;
  surfaceViewBase: typeof PORTFOLIO_SURFACE_BASE;
  savedViewBase: typeof PORTFOLIO_SAVED_VIEW_BASE;
  surfaceHome: typeof PORTFOLIO_SURFACE_BASE;
};

const PORTFOLIO_PATHS = {
  surfaceViewBase: PORTFOLIO_SURFACE_BASE,
  savedViewBase: PORTFOLIO_SAVED_VIEW_BASE,
  surfaceHome: PORTFOLIO_SURFACE_BASE,
} as const;

export function useViewSurfacePaths(): ViewSurfacePaths {
  const matchRoute = useMatchRoute();
  const isMergedPortfolio = !!matchRoute({ to: PORTFOLIO_SURFACE_BASE, fuzzy: true });
  return { isMergedPortfolio, ...PORTFOLIO_PATHS };
}
